module.exports = __webpack_public_path__ + "img/bg_1.80a3f02b.png";